import React from 'react';
import { Link } from 'react-router-dom';
import './Menu.scss';

const Menu = props => {
    return (
        <div className="menu">
            <div className="container">
                <nav>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        {/* <li><Link to="/ofertas">Ofertas</Link></li> */}
                        <li><Link to="/sobre">Sobre nós</Link></li>
                        <li><Link to="/catalogos">Catálogos</Link></li>
                        <li><Link to="/duvidas">Dúvidas</Link></li>
                        <li><Link to="/faleconosco">Fale Conosco</Link></li>
                        <li className="destaque"><Link to="//www.sicredi.com.br/segundaviaboleto/" target={"_blank"}>2ª Via do boleto</Link></li>
                        
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default Menu;